module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Ca-Db-Ef-Gd.dda9fbf7.png";